import React, { useContext } from 'react';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import { toast } from 'react-toastify';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { AppContext } from '../../../contexts/AppContext';
import ActiveControl from '../../../components/ActiveControl';
import useEventTypeService from '../../../app/services/hooks/useEventTypeService';

interface Props {
    eventTypeId: number;
    checkValue: boolean;
    callbackSuccess: () => void;
}

const EventTypeSwitchChange = ({ eventTypeId, checkValue, callbackSuccess }: Props) => {
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const [checked, setChecked] = React.useState<boolean>(checkValue);

    const { activeEventType, fetchingActiveEventType } = useEventTypeService();

    const active = (value: boolean) => {
        setChecked(value);

        activeEventType(eventTypeId, value, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });

                callbackSuccess();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                setChecked(!value);
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            }
        });
    };

    return <ActiveControl status={checked} id={eventTypeId} callback={active} />;
};

export default EventTypeSwitchChange;
